import Icon from '../components/Icon.vue'

Icon.register({
  'file-powerpoint': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M193.7 271.2C202.5 271.2 209.2 273.9 214 279.3 223.6 290.2 223.8 312 213.8 323.4 208.9 329 201.9 331.9 192.7 331.9H165.8V271.2H193.7zM377 105L279 7C274.5 2.5 268.4 0 262 0H256V128H384V121.9C384 115.6 381.5 109.5 377 105zM224 136V0H24C10.7 0 0 10.7 0 24V488C0 501.3 10.7 512 24 512H360C373.3 512 384 501.3 384 488V160H248C234.8 160 224 149.2 224 136zM277 301.2C277 391.5 188.2 378.8 165.9 378.8V436C165.9 442.6 160.5 448 153.9 448H123.1C116.5 448 111.1 442.6 111.1 436V236.2C111.1 229.6 116.5 224.2 123.1 224.2H204.1C248.6 224.2 277 257 277 301.2z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/file-powerpoint.js
// module id = FumG
// module chunks = 144